export interface IFeaturedOffer {
  deglawyOfferId?: number;
  featuredOfferId?: number;
  title?: string;
  order?: number;
  description?: string;
  imageURL?: string;
  type?: OfferTypes;
  isHotDeal?: boolean;
  discountPercentage?: number,
}

export enum OfferTypes {
  DSQUARES = 'DSQUARES',
  CUSTOM = 'CUSTOM',
  ALL = 'ALL'
}